export const RequestState = {
  NotRequested: "NotRequested",
  InProgress: "InProgress",
  Finished: "Finished",
  Failed: "Failed"
};
